<template>
    <div class="conatiner">
        <div class="content">
            <div class="imgbox">
                <img @click="navToDetail(2)" src="@/assets/women-world-cup-personal-summary/img/3人教练.png" />
                <img @click="navToDetail(1)" src="@/assets/women-world-cup-personal-summary/img/5人教练.png" />
            </div>
            <div class="logo">
                <img src="@/assets/women-world-cup-personal-summary/img/logo.png" />
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
// import videoDialog from '@/components/videoDialog'

export default defineComponent({
    name: 'Home',
    components: {
        // videoDialog,
    },
    setup() {
        // console.log("teamData", teamData);
        const router = useRouter()
        const navToDetail = (type) => {
            if (type === 1) {
                router.push({
                    name: 'PlayerSummary',
                    query: {},
                })
            } else if (type === 2) {
                router.push({
                    name: 'TeamPage',
                    query: {},
                })
            }
        }

        function setdata() {
            let match1 = require('../../assets/word_cup_data/2022-2-10-China-Nigeria/China_panel_data.json')
            let match2 = require('../../assets/word_cup_data/2022-2-11-Mali-China/China_panel_data.json')
            let match3 = require('../../assets/word_cup_data/2022-2-14-France-China/China_panel_data.json')

            let match1w = require('../../assets/word_cup_data/2022-2-10-China-Nigeria/China_DF_data.json')
            let match2w = require('../../assets/word_cup_data/2022-2-11-Mali-China/China_DF_data.json')
            let match3w = require('../../assets/word_cup_data/2022-2-14-France-China/China_DF_data.json')
            // let matchall = {
            //     '2022-2-10-China-Nigeria': Object.assign({}, match1, match1w),
            //     '2022-2-11-Mali-China': Object.assign({}, match2, match2w),
            //     '2022-2-14-France-China': Object.assign({}, match3, match3w),
            // }

            let matchall = {
                '2022-2-10-China-Nigeria': match1.map((item) => {
                    let data =
                        match1w.find((aa) => {
                            return aa.name == item.name
                        }) || {}
                    return { ...data, ...item }
                }),
                '2022-2-11-Mali-China': match2.map((item) => {
                    let data =
                        match2w.find((aa) => {
                            return aa.name == item.name
                        }) || {}
                    return { ...data, ...item }
                }),
                '2022-2-14-France-China': match3.map((item) => {
                    let data =
                        match3w.find((aa) => {
                            return aa.name == item.name
                        }) || {}
                    return { ...data, ...item }
                }),
            }
            // console.log(match1, match1w)
            let attack1 = require('../../assets/word_cup_data/2022-2-10-China-Nigeria/player_play_type_data.json')
            let attack2 = require('../../assets/word_cup_data/2022-2-11-Mali-China/player_play_type_data.json')
            let attack3 = require('../../assets/word_cup_data/2022-2-14-France-China/player_play_type_data.json')
            let attackall = {
                '2022-2-10-China-Nigeria': attack1,
                '2022-2-11-Mali-China': attack2,
                '2022-2-14-France-China': attack3,
            }
            console.log(attackall)
            let aa = require('../../assets/women-world-cup-personal-summary/模板.json')
            let match = {}
            let attack = {}
            Object.keys(aa).forEach((name) => {
                if (name.charAt(name.length - 1) == '1') {
                    match[name.slice(0, name.length - 1)] = JSON.parse(JSON.stringify(aa[name][0]))
                } else {
                    attack[name.slice(0, name.length - 1)] = aa[name]
                }
            })
            let attackobj = { '2022-2-10-China-Nigeria': {}, '2022-2-11-Mali-China': {}, '2022-2-14-France-China': {} }
            Object.keys(matchall).forEach((name) => {
                matchall[name].forEach((item) => {
                    attackobj[name][item.name] = item
                })
            })
            let newmatch = JSON.parse(JSON.stringify(match))
            Object.keys(attackobj).forEach((name) => {
                Object.keys(match).forEach((matchName) => {
                    let matchobjData = attackobj[name][matchName]
                    // console.log(matchobjData, matchName)
                    if (matchobjData) {
                        // match[matchName]
                        Object.keys(matchobjData).forEach((matchobjDatakey) => {
                            if (Array.isArray(matchobjData[matchobjDatakey])) {
                                if (!newmatch[matchName][matchobjDatakey]) {
                                    newmatch[matchName][matchobjDatakey] = {}
                                }

                                newmatch[matchName][matchobjDatakey][name] = matchobjData[matchobjDatakey]
                            } else if (typeof matchobjData[matchobjDatakey] == 'object') {
                                if (!newmatch[matchName][matchobjDatakey]) {
                                    newmatch[matchName][matchobjDatakey] = {
                                        time: {},
                                    }
                                }
                                if (!newmatch[matchName][matchobjDatakey].time) {
                                    newmatch[matchName][matchobjDatakey].time = {}
                                }

                                newmatch[matchName][matchobjDatakey].time[name] = matchobjData[matchobjDatakey].time

                                newmatch[matchName][matchobjDatakey].value = match[matchName][matchobjDatakey]?.info || ''
                            } else {
                                newmatch[matchName][matchobjDatakey] = match[matchName][matchobjDatakey]?.info || ''
                                if (matchobjDatakey == 'num') {
                                    newmatch[matchName][matchobjDatakey] = matchobjData[matchobjDatakey]
                                }
                            }
                        })
                    }
                })
            })
            let newattack = JSON.parse(JSON.stringify(attack))
            Object.keys(attackall).forEach((name) => {
                attackall[name].forEach((attackdata, index) => {
                    if (attackdata.team != 'China') {
                        return
                    }
                    let myplayTypesObj = {}
                    attack[attackdata.name]?.forEach((playTypedata) => {
                        myplayTypesObj[playTypedata.PLAYTYPE?.info] = playTypedata
                    })

                    attackdata.playTypes.forEach((playTypedata) => {
                        let matchobjData = myplayTypesObj[playTypedata.PLAYTYPE]

                        if (matchobjData) {
                            Object.keys(playTypedata).forEach((playTypedatakey) => {
                                let newmyplayTypesObj = newattack[attackdata.name].find((newdata) => {
                                    // console.log(newdata.PLAYTYPE, playTypedata.PLAYTYPE)
                                    return (newdata.PLAYTYPE?.info || newdata.PLAYTYPE) == playTypedata.PLAYTYPE
                                })
                                // console.log(newmyplayTypesObj)
                                if (typeof playTypedata[playTypedatakey] == 'object') {
                                    if (!newmyplayTypesObj[playTypedatakey]) {
                                        newmyplayTypesObj[playTypedatakey] = {
                                            time: {},
                                        }
                                    }
                                    if (!newmyplayTypesObj[playTypedatakey].time) {
                                        newmyplayTypesObj[playTypedatakey].time = {}
                                    }

                                    newmyplayTypesObj[playTypedatakey].time[name] = playTypedata[playTypedatakey]?.time

                                    newmyplayTypesObj[playTypedatakey].value = matchobjData[playTypedatakey]?.info || ''
                                } else {
                                    newmyplayTypesObj[playTypedatakey] = matchobjData[playTypedatakey]?.info || ''
                                }
                            })
                        }
                    })
                })
            })

            console.log(JSON.stringify(newmatch))
            console.log(JSON.stringify(newattack))
        }
        // setdata()
        // match.forEach
        return {
            navToDetail,
        }
    },
})
</script>

<style scoped lang="less">
.conatiner {
    width: 100vw;
    height: 100vh;
    // padding-bottom: 62.5vw;
    min-height: 49.9vw;
    overflow-y: scroll;
    background: url('~@/assets/women-world-cup-personal-summary/img/背景.jpg') no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    // background-color: #570206;
    // box-sizing: border-box;
    // padding: 1.5rem 16rem;
    // position: relative;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .content {
        width: 100vw;
        height: 49.9vw;
        margin: 0 auto;
        min-height: 49.9vw;
        overflow-y: scroll;
        // background-image: linear-gradient(0deg, rgba(78, 6, 12, 1) 0%, rgba(29, 190, 223, 0) 100%) url('~@/assets/women-world-cup-personal-summary/img/文字.png');
        background: linear-gradient(0deg, rgba(78, 6, 12, 1) 0%, rgba(0, 0, 0, 0) 20%),
            url('~@/assets/women-world-cup-personal-summary/img/文字.png') no-repeat;
        background-size: 80% 100%;
        background-position: top center;
        box-shadow: 0 5px 5px #4e060c;
        position: relative;
        .imgbox {
            width: 16%;
            height: auto;
            display: flex;
            position: absolute;
            top: 17vw;
            right: 26vw;
            flex-direction: column;
            img {
                width: 100%;
                margin: 20px 0;
            }
        }
        .logo {
            width: 260px;
            bottom: 15px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            img {
                width: 100%;
            }
        }
    }
}

@media screen and (max-width: 500px) {
    .conatiner {
        min-height: 193.7vw;
        background: rgba(78, 6, 12, 1);
        .content {
            width: 100vw;
            background: url('~@/assets/women-world-cup-personal-summary/img/movebeijing.png') no-repeat;
            background-size: 100%;
            background-position: top center;
            background-color: #570206;
            min-height: 193.7vw;
            .imgbox {
                width: 100%;
                height: auto;
                display: flex;
                position: absolute;
                top: 145vw;
                right: 0;
                flex-direction: row;
                img {
                    width: calc(50% - 20px);
                    margin: 0 10px;
                }
            }
            .logo {
                width: 190px;
                bottom: 30px;
            }
        }
    }
}
</style>
